// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@awc/Overrides/Widgets/BrandDetails/BrandDetailsCategories";
import ArrowRight from "@awc/XDL/Icons/ArrowRight";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@awc/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.categoryContainer = {
    gap: 15,
};

categoriesStyles.container = {
    css: css`
        margin-top: 25px;
    `,
};

categoriesStyles.innerCategoryContainer = {
    gap: 1,
    css: css`
        width: 100%;
        height: 100%;
        padding: 24px 12px 12px 24px;
        border: 1px solid ${color("common.border")};
    `,
};

categoriesStyles.categoryItemRow = {
    width: [12, 12, 6, 4, 4],
};

categoriesStyles.subCategoryItem = {
    width: 12,
    css: css`
        padding-top: 2px;
        padding-bottom: 3px;
        flex-direction: column;
        ul > li {
            margin-bottom: 0 !important;
        }
    `,
};

categoriesStyles.title = {
    variant: "h2",
    color: "text.main",
};

categoriesStyles.categoryNameLink = {
    mergeCss: true,
    typographyProps: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    css: css`
        width: 100%;
    `,
};

categoriesStyles.subCategoryLink = {
    mergeCss: true,
    typographyProps: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    color: "text.main",
    css: css`
        width: 100%;
    `,
};

categoriesStyles.viewMoreLink = {
    ...createLinkIconStyles({
        icon: ArrowRight,
        linkStyles: {
            icon: {
                iconProps: {
                    color: "text.main",
                },
                position: "right",
            },
            color: "text.main",
        },
        sizeVariant: "large",
    }),
};

categoriesStyles.sub3Link = {
    typographyProps: {
        weight: fontConfig.weight.regular,
    },
};
